import gql from 'graphql-tag';
import { change } from 'redux-form';
import history from '../../../history';
import showToaster from '../../../helpers/showToaster';

const mutation = gql`
mutation createBooking($riderId:ID,$driverId:ID,$categoryId:Int!,$totalDistance:Float!,$totalDuration:Float!,$firstName:String!,$lastName:String!,$email:String!,$phoneDialCode:String!,$phoneNumber:String!,$phoneCountryCode:String!,$currency:String!,$distanceType:String!,$bookingLocations:[BookingLocationsInputObjectType]!, $bookingType: Int!, $scheduleFrom: Int, $isWomenOnlyDriver: Boolean, $isChildSeatAvailable: Boolean, $isWheelChairAvailable: Boolean, $gender: String) {
  createBooking(riderId:$riderId,driverId:$driverId,categoryId:$categoryId,totalDistance:$totalDistance,totalDuration:$totalDuration,firstName:$firstName,lastName:$lastName,email:$email,phoneDialCode:$phoneDialCode,phoneNumber:$phoneNumber,phoneCountryCode:$phoneCountryCode,currency:$currency,distanceType:$distanceType,bookingLocations:$bookingLocations, bookingType: $bookingType, scheduleFrom: $scheduleFrom, isWomenOnlyDriver: $isWomenOnlyDriver, isChildSeatAvailable: $isChildSeatAvailable,  isWheelChairAvailable: $isWheelChairAvailable, gender: $gender) {
    status
    errorMessage
    result {
        id
    }
  }
}
`;

export default function createBooking(variables) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch(change("ManualBookingForm", "loaders.finalStep", true));
            const { data } = await client.mutate({
                mutation,
                variables
            });

            if (data && data.createBooking && data.createBooking.status === 200) {
                history.push(`/siteadmin/manual-bookings/view/${data.createBooking.result.id}`)
            } else {
                showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.createBooking?.errorMessage })
            }
            dispatch(change("ManualBookingForm", "loaders.finalStep", false));
            return true;
        } catch (error) {
            dispatch(change("ManualBookingForm", "loaders.finalStep", false));
            showToaster({ messageId: 'catchError', toasterType: 'error', requestContent: error })
            return false;
        }
    };
}